/**
 * Utility functions for case note line break handling
 * Ensures compatibility between web app (Unix \n) and CheckLine (Windows \r\n)
 */

/**
 * Normalizes line breaks from Windows format (\r\n) to Unix format (\n)
 * Used when loading case notes from the database
 */
export function normalizeLineBreaks(text: string): string {
  return text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
}

/**
 * Converts line breaks from Unix format (\n) to Windows format (\r\n)
 * Used when saving case notes to ensure CheckLine compatibility
 */
export function convertToWindowsLineBreaks(text: string): string {
  // First normalize any existing \r\n to \n, then convert all \n to \r\n
  return text.replace(/\r\n/g, '\n').replace(/\n/g, '\r\n');
}
